// Global colors
export const colors = {
  primaryCyan: 'hsl(180, 66%, 49%)',
  primaryViolet: 'hsl(257, 27%, 26%)',
  red: 'hsl(0, 87%, 67%)',
  gray: 'hsl(0, 0%, 75%)',
  grayishViolet: 'hsl(257, 7%, 63%)',
  darkBlue: 'hsl(255, 11%, 22%)',
  darkViolet: 'hsl(260, 8%, 14%)',
  lightGray: '#eff1f7',
  white: '#ffffff',
  darkenPrimaryCyan: '#26BABA'
};

// Global padding
export const globalTopBottomPadding = '4rem';
export const globalLeftRightPadding = '10rem';

// Global margin
export const featureMarginTop = '-20rem';

// Breakpoints
export const breakpoints = {
  sMobile: '375px',
  mMobile: '414px',
  lMobile: '600px',
  sTablet: '768px',
  mTablet: '800px',
  lTablet: '1024px',
  sDesktop: '1280px',
  mDesktop: '1366px',
  lDesktop: '1440px'
};

// Typograhy
export const globalFontFamily = `Poppins, sans-serif`;
